// extracted by mini-css-extract-plugin
export default {"header":"header_header__A7NEZ","metadata":"header_metadata__Z5zCh"};